import {I18n} from 'aws-amplify/utils';
import {
    Text,
    Tooltip,
} from '@mantine/core';

import {
    DnsZone,
    recordCountState,
} from '../types';

// ⚠️ "NOT REPORTED" AND "0 RECORDS" ARE DIFFERENT SENTENCES (FNP-1422).
//
// This is NameserverCount's problem with the polarity reversed, and the reversal
// is what makes it worse. There, an empty list is always "not loaded" because
// the list path never reads the delegation set — one state, one rendering. Here
// the API genuinely returns both: Route 53 puts ResourceRecordSetCount on every
// zone in its listing, so a real zero arrives as `0`, while a provider that
// cannot count without walking its records answers null.
//
// So `0` must render as a COUNT and null must render as an ABSENCE, and the
// difference has to be visible on screen rather than merely present in the
// data. An operator reading "0 records" on a zone nobody counted may conclude
// the zone is safe to delete — the count is a snapshot, and it is never the
// authority on emptiness anyway (deleteDnsZone refusing with ZONE_NOT_EMPTY is
// that). Rendering the two the same way is how a display field becomes a
// destructive decision.
//
// The dash matches NameserverCount's treatment of an unknown, so the table has
// ONE visual vocabulary for "we do not know" rather than two.
//
// Its own file because a module that also exports a hook or a constant breaks
// Fast Refresh, and this lints at --max-warnings 0.
export const RecordCount = ({zone}: { zone: DnsZone }) => {

    const state = recordCountState(zone);

    if (state.kind === 'NOT_REPORTED') {
        return (
            <Tooltip
                label={I18n.get('This provider did not report a record count for the zone. That is not the same as the zone being empty.')}
                withArrow={true}
            >
                <Text size={'sm'} c={'dimmed'}>—</Text>
            </Tooltip>
        );
    }

    // A REAL count, including a real zero. Rendered plainly, as a number.
    return <Text size={'sm'}>{state.count}</Text>;
};
